import React, { useCallback, useState } from 'react';
import MobilePanel from 'components/mobile-panel/mobile-panel';
import MobileMenu from 'components/mobile-menu/mobile-menu';
import Logo from 'components/logo/logo';
import Button from 'components/button/button';
import Icon from 'components/icon/icon';
import { useMenu } from 'components/menu/use-menu';
import { Menu } from 'interfaces/microsite-cms';

type PageMobilePanelProps = {
    menu?: Menu;
};

export default function PageMobilePanel({ menu }: PageMobilePanelProps) {
    const [isActive, setIsActive] = useState(false);

    const closePanel = useCallback(() => {
        global.document.body.classList.toggle('is-opened-mobile-nav', false);
        setIsActive(false);
    }, []);

    const mobileMenu = useMenu({ menu });

    return (
        <MobilePanel
            logo={<Logo color="inherit" isOld={false} isNew={true} />}
            isActive={isActive}
            closePanel={closePanel}
            closeAction={
                <Button
                    isCircle={true}
                    jsClass="js-close-menu"
                    icon={<Icon size="md" name={Icon.Name.Close} />}
                    onClick={closePanel}
                />
            }
            menuList={[
                ...mobileMenu.map((menuItem: any, index: any) => (
                    <MobileMenu {...menuItem} key={`item-${index}`} />
                )),
            ]}
        />
    );
}
